export const BASE_URL =
  "https://crypto-dashboard-backend.emiliodeng98.workers.dev";
